import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/view/login/Login'], resolve),
    },{
      path: '/home',
      name: 'home',
      component: resolve => require(['@/view/home/Home'], resolve),
    },{
      path: '/check',
      name: 'check',
      component: resolve => require(['@/view/check/Check'], resolve),
    },{
      path: '/test',
      name: 'test',
      component: resolve => require(['@/view/test/Test'], resolve),
    },{
      path: '/finish',
      name: 'finish',
      component: resolve => require(['@/view/finish/Finish'], resolve),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js